import { Component, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Discussion } from "../../../../models";
import { environment } from "../../../../../../environments/environment";

declare const FB: any;

@Component({
  selector: "social-share-buttons",
  templateUrl: "./social-share-buttons.component.html",
  styleUrls: [
    "./social-share-buttons.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class SocialShareButtonsComponent {
  public twitterShareURL;
  public whatsAppShareURL;
  public linkedInShareURL;
  public articleURL;
  public source: string = "uMuzi";
  public isSubmitting = false;
  @Input() discussion: Discussion;

  constructor(private sanitizer: DomSanitizer) {
    // this.initializeFaceBookData()
  }

  ngOnInit() {
    this.articleURL = "https://umuzi.net/discussion/" + this.discussion.slug;

    this.twitterShareURL = this.sanitizer.bypassSecurityTrustUrl(
      `https://twitter.com/share?hashtags=${this.discussion.tagList.join()}&text=${
        this.discussion.title
      }`
    );

    this.whatsAppShareURL = this.sanitizer.bypassSecurityTrustUrl(
      `https://api.whatsapp.com/send?text=${this.discussion.title}`
    );
  }

  public initializeFaceBookData() {
    FB.init({
      appId: environment.facebookConfig.appId,
      status: false,
      cookie: false,
      xfbml: false,
      version: "v4.0",
    });
  }

  public shareToFacebook() {
    FB.ui(
      {
        method: "feed",
        name: "Facebook Dialogs",
        link: this.articleURL,
        picture:
          "https://firebasestorage.googleapis.com/v0/b/umuzi-f655c.appspot.com/o/images%2Fcommunities%2FCIM-Africa?alt=media&token=c68426fd-42af-4db5-8641-f4bcfadceb51",
        caption: "Discover stories on uMuzi",
        description: this.discussion.title,
        message: "Facebook Dialogs are easy!",
      },
      function (response) {
        if (response && response.post_id) {
        } else {
        }
      }
    );
  }
}
